/* eslint-disable react/jsx-no-useless-fragment */
import FilterListIcon from '@mui/icons-material/FilterList';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Alert } from '../../../../components/singleComponents/alerts/Alert';
import { TablePayables } from '../../../../components/singleComponents/tables/TablePayables';
import { BudgetInfo } from '../../../admin/constructions/ConstructionsDetails/budgets/BudgetInfo';
import MobileFilter from './MobileFilter/MobileFilter';

import api, { authHeader } from '../../../../../services/API/apiConfig';

import '../../home/toogle.css';
import {
  BarsContainerStyled,
  BtnStyled,
  CardPayableStyled,
  DesktopViewStyled,
  FilterStyled,
  HeaderContainerStyled,
  ListStyled,
  LoaderContainerStyled,
  MobileDivStyled,
  MobileTitleStyled,
  PaidBarStyled,
  PayableDueStyled,
  PayableListStyled,
  PayablesCardStyled,
  PayablesCountStyled,
  PayableTotalStyled,
  PendingBarStyled,
  SupplierNameStyled,
} from './ConstructionPayable.styles';

export function ConstructionPayable() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [payables, setPayables] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [paid, setPaid] = useState();
  const [pending, setPending] = useState();
  const [paidPercent, setPaidPercent] = useState(0);
  const [pendingPercent, setPendingPercent] = useState(0);
  const [sumPayable, setSumPayable] = useState(0);
  const [permissionPayable, setPermissionPayable] = useState(true);
  const [headerInfo, setHeaderInfo] = useState({});
  const [suppliers, setSuppliers] = useState([]);
  const [filter, setFilter] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [hasBudget, setHasBudget] = useState(false);

  const [loading, setLoading] = useState(true);
  const [exportKey, setExportKey] = useState(null);

  const headings = [
    'Vencimento',
    'Fornecedor',
    'Descrição',
    'Item',
    'Valor',
    'Status',
    'Lançamento',
    'Anexos',
  ];

  const exportPayable = () => {
    const payablesIds = filterData
      .map(({ id: payableId }) => payableId)
      .join(',');

    api
      .get(
        `/constructions/${id}/payable_xlsx?export_key=${exportKey}&payables_ids=${payablesIds}`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const { baseURL, url } = res.config;
        window.open(baseURL + url);
      });
  };

  // TODO: duplicate funcs?
  const displayAttachments = (payableId) => {
    navigate(`/detailed-payable/${payableId}`);
  };

  const handleGoToDetailedPayable = (payableId) => {
    navigate(`/detailed-payable/${payableId}`);
  };

  const getPayables = async () => {
    api
      .get(`/constructions/${id}/payables`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data, sum } = res.data;
        setPayables(data);
        setSumPayable(sum);
        setPermissionPayable(true);
        setLoading(false);
        const uniqueSuppliers = {};
        data
          .map((d) => d.supplier)
          .forEach((item) => {
            uniqueSuppliers[item.id] = item;
          });
        setSuppliers(Object.values(uniqueSuppliers));
      })
      .catch(() => {
        setLoading(false);
        setPermissionPayable(false);
      });
  };

  const renderPayableItems = (payable) => {
    let content = payable?.category?.name || '';

    if (payable.payable_items.length === 1) {
      content = payable.payable_items[0].category.name;
    }

    if (payable.payable_items.length > 1) {
      content = `${payable.payable_items.length} itens associados`;
    }

    return (
      <Typography className="categoryName" variant="body2" color="primary">
        {content}
      </Typography>
    );
  };

  useEffect(() => {
    api
      .get(`/constructions/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setPayables(data);
        setExportKey(data?.export_key);
      });
  }, []);

  useEffect(() => {
    async function getBudget() {
      await api
        .get(`/constructions/${id}/details?budget=false`, {
          headers: authHeader(),
        })
        .then((res) => setHeaderInfo(res.data.data));
    }

    async function getBudgetInfo() {
      await api
        .get(`/constructions/${id}/budgets?array=false`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          console.log(data);
          if (data.items !== undefined && data.items.length) {
            setHasBudget(true);
          }
        });
    }

    getPayables();
    getBudget();
    getBudgetInfo();
  }, [id]);

  useEffect(() => {
    let paidValue = 0;
    let pendingValue = 0;
    if (payables.length) {
      for (let i = 0; i < payables.length; i += 1) {
        if (payables[i].status === 'Pendente') {
          let value = payables[i].total;
          value = value
            .replace('R$', '')
            .replace(' ', '')
            .replace('.', '')
            .replace(',', '.');
          value = parseFloat(value);
          pendingValue += value;
        } else if (payables[i].status === 'Pago') {
          let value = payables[i].total;
          value = value
            .replace('R$', '')
            .replace(' ', '')
            .replace('.', '')
            .replace(',', '.');
          value = parseFloat(value);
          paidValue += value;
        }
      }
    }
    setPaidPercent((paidValue * 100) / sumPayable);
    setPendingPercent((pendingValue * 100) / sumPayable);
    setPaid(paidValue);
    setPending(pendingValue);
  }, [payables, paidPercent, pendingPercent, paid, pending, sumPayable]);

  return (
    <>
      {loading ? (
        <LoaderContainerStyled>
          <LinearProgress style={{ width: '80%' }} />
        </LoaderContainerStyled>
      ) : (
        <>
          {permissionPayable ? (
            <>
              <DesktopViewStyled>
                <HeaderContainerStyled>
                  <Typography variant="h2">{headerInfo.name}</Typography>
                  <BtnStyled
                    variant="outlined"
                    onClick={exportPayable}
                    disabled={!payables.length}
                  >
                    Exportar lançamento
                  </BtnStyled>
                </HeaderContainerStyled>
                {hasBudget && <BudgetInfo info={headerInfo} />}
                <TablePayables
                  filter={filter}
                  setFilter={setFilter}
                  data={payables}
                  constructionId={id}
                  headings={headings}
                  callbackClickRow={displayAttachments}
                  isConstruction
                  filterData={filterData}
                  setFilterData={setFilterData}
                />
              </DesktopViewStyled>
              <MobileDivStyled>
                <MobileTitleStyled variant="h2">Lançamentos</MobileTitleStyled>
                <CardPayableStyled>
                  {(pendingPercent !== 0 || paidPercent !== 0) && (
                    <BarsContainerStyled>
                      <PaidBarStyled
                        style={{ height: paidPercent !== 0 ? paidPercent : 2 }}
                      />
                      <PendingBarStyled
                        style={{
                          height: pendingPercent !== 0 ? pendingPercent : 2,
                        }}
                      />
                    </BarsContainerStyled>
                  )}
                  <PayablesCardStyled>
                    <Typography variant="body2" className="payment">
                      Pagamento realizado{' '}
                      <span className="paid">
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(paid)}
                      </span>
                    </Typography>
                    <Typography variant="body2" className="payment">
                      Pagamento pendente{' '}
                      <span className="pending">
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(pending)}
                      </span>
                    </Typography>
                  </PayablesCardStyled>
                </CardPayableStyled>

                <div style={{ marginTop: 64, marginBottom: '32px' }}>
                  <FilterStyled>
                    <PayablesCountStyled variant="body2">
                      {`Lançamentos: ${payables?.length}`}
                    </PayablesCountStyled>
                    <button onClick={() => setOpenFilter(true)} type="button">
                      Filtrar
                      <FilterListIcon />
                    </button>
                  </FilterStyled>
                  {payables?.length > 0 &&
                    payables?.map((payable) => (
                      <ListStyled
                        onClick={() => handleGoToDetailedPayable(payable.id)}
                      >
                        <PayableListStyled key={payable.id}>
                          <div className="supplierName">
                            <SupplierNameStyled variant="body2">
                              {payable.supplier.name}
                            </SupplierNameStyled>
                            {payable !== null && renderPayableItems(payable)}
                          </div>
                          <div className="pendingPayment">
                            <PayableDueStyled
                              variant="body1"
                              style={{
                                color:
                                  payable.status === 'Pendente'
                                    ? '#FF4A56'
                                    : '#29D17D',
                              }}
                            >
                              Venc. {payable.due}
                            </PayableDueStyled>
                            <PayableTotalStyled
                              variant="body1"
                              style={{
                                color:
                                  payable.status === 'Pendente'
                                    ? '#FF4A56'
                                    : '#29D17D',
                              }}
                            >
                              {payable.total}
                            </PayableTotalStyled>
                          </div>
                        </PayableListStyled>
                      </ListStyled>
                    ))}
                </div>
              </MobileDivStyled>
              <MobileFilter
                suppliers={suppliers}
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                id={id}
                getPayables={getPayables}
                filter={filter}
                setFilter={setFilter}
              />
            </>
          ) : (
            <Alert alertTitle="Lançamentos indisponível" />
          )}
        </>
      )}
    </>
  );
}
